module.exports = __webpack_public_path__ + "img/chart-bar-regular.63fe9700.svg";